import { produce } from 'immer';

import { RESET_STATE } from 'store/global/actions';

import { TEXML_APPLICATIONS_ACTION_TYPE } from '../actions';

const initialState = {
  texmlApplications: [],
  phoneNumbers: [],
};

const texmlApplicationsReducer = (state = initialState, { type, payload }) =>
  produce(state, draft => {
    switch (type) {
      case TEXML_APPLICATIONS_ACTION_TYPE.GET_TEXML_APPLICATIONS:
        draft.texmlApplications = payload;
        break;

      case TEXML_APPLICATIONS_ACTION_TYPE.CREATE_TEXML_APPLICATION:
        draft.texmlApplications = [...state.texmlApplications, payload];
        break;

      case TEXML_APPLICATIONS_ACTION_TYPE.UPDATE_TEXML_APPLICATION:
        draft.texmlApplications = state.texmlApplications.map(item =>
          item.id === payload.id ? { ...item, ...payload } : item,
        );
        break;

      case TEXML_APPLICATIONS_ACTION_TYPE.DELETE_TEXML_APPLICATION:
        draft.texmlApplications = state.texmlApplications.filter(item => item.id !== payload);
        break;

      case TEXML_APPLICATIONS_ACTION_TYPE.GET_PHONE_NUMBERS:
        draft.phoneNumbers = payload;
        break;

      case RESET_STATE:
      case TEXML_APPLICATIONS_ACTION_TYPE.RESET_TEXML_APPLICATIONS_STATE:
        return initialState;

      default:
        break;
    }
  });

export default texmlApplicationsReducer;
